module.exports = __webpack_public_path__ + "img/add-photo.14586edc.svg";